module.exports = __webpack_public_path__ + "img/title-th.4c2c6259.png";